import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Download } from "lucide-react";

export const LeadsCard = () => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/leads").then(r => setD(r.data)).catch(() => {}); }, []);

  const download = async () => {
    try {
      const r = await api.get("/admin/leads.csv", { responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement("a");
      a.href = url; a.download = "leads.csv"; a.click();
      URL.revokeObjectURL(url);
    } catch { toast.error("Couldn't download the list."); }
  };

  if (!d) return null;
  return (
    <div className="card-panel p-5" data-testid="leads-card">
      <div className="flex items-center justify-between gap-3">
        <div>
          <div className="eyebrow text-[#FD0F10]">LEADS ({d.count})</div>
          <p className="text-xs text-gray-500 mt-1">{d.signed_up} finished signing up · {d.count - d.signed_up} left only their email</p>
        </div>
        <button onClick={download} className="inline-flex items-center gap-1.5 text-xs font-mono-ui uppercase tracking-wider border border-[#2A2E39] hover:border-white px-3 py-1.5 rounded" data-testid="leads-download-btn"><Download size={12} /> Download CSV</button>
      </div>
      <div className="mt-3 overflow-x-auto max-h-96 overflow-y-auto">
        <table className="w-full min-w-[480px] text-xs" data-testid="leads-table">
          <thead className="text-gray-500 font-mono-ui uppercase">
            <tr><th className="text-left py-1 pr-2">Email</th><th className="px-2">Date</th><th className="pl-2">Status</th></tr>
          </thead>
          <tbody>
            {d.leads.map((l, i) => (
              <tr key={l.email} className="border-t border-[#2A2E39] text-gray-300" data-testid={`lead-row-${i}`}>
                <td className="py-1.5 pr-2 break-words">{l.email}</td>
                <td className="px-2 text-center">{l.date ? new Date(l.date).toLocaleDateString() : "-"}</td>
                <td className={`pl-2 text-center ${l.status === "Signed up" ? "text-green-400" : "text-gray-400"}`} data-testid={`lead-status-${i}`}>{l.status}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {d.leads.length === 0 && <p className="text-xs text-gray-500 mt-2">No leads yet.</p>}
      </div>
    </div>
  );
};
